"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EncryptedNotice = EncryptedNotice;
var _react = _interopRequireDefault(require("react"));
var ENCRYPTED_SHIELD_ICON = /*#__PURE__*/_react["default"].createElement("svg", {
  className: "shrink-0 text-accent-regular/90",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  "aria-hidden": "true"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M7 1.4 3 3v3.1c0 2.7 1.6 5 4 6 2.4-1 4-3.3 4-6V3L7 1.4Z",
  stroke: "currentColor",
  strokeWidth: "1.2",
  strokeLinejoin: "round"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "m5.5 7.1.9.9 2.1-2.2",
  stroke: "currentColor",
  strokeWidth: "1.1",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

/**
 * EncryptedNotice component.
 *
 * Render the encrypted-data notice used by stored-card flows.
 *
 * @param {object} props - Component props.
 * @param {boolean} props.available - Whether the notice should be displayed.
 * @param {React.ReactNode} props.label - Encrypted-data notice copy.
 * @returns {React.ReactElement|null} Encrypted-data notice when available.
 */
function EncryptedNotice(_ref) {
  var _ref$available = _ref.available,
    available = _ref$available === void 0 ? false : _ref$available,
    label = _ref.label;
  if (!available) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center gap-1.5 pt-1",
    "data-sentry-component": "EncryptedNotice",
    "data-sentry-source-file": "EncryptedNotice.tsx"
  }, ENCRYPTED_SHIELD_ICON, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs font-semibold text-accent-regular"
  }, label));
}